(() => {
  if (window.slReviewsReady) return;
  window.slReviewsReady = true;

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-sl-reviews-more]');
    if (!button) return;
    const wall = document.getElementById(button.getAttribute('aria-controls'));
    if (!wall) return;

    const firstHidden = wall.querySelector('.sl-reviews__item--more');
    wall.classList.remove('is-collapsed');
    button.setAttribute('aria-expanded', 'true');
    button.closest('.sl-reviews__more').hidden = true;

    const focusTarget = firstHidden && firstHidden.querySelector('.sl-review');
    if (focusTarget) {
      focusTarget.setAttribute('tabindex', '-1');
      focusTarget.focus({ preventScroll: true });
    }
  });
})();
